import React from 'react';
import { Box, Typography } from '@mui/material';
import TPOPaper from '../TPOPaper/TPOPaper';

interface PaperSectionProps {
  title: string;
  subtitle?: string;
  bannerColor?: string;
  variant?: 'default' | 'plain';
  children?: React.ReactNode;
}

const PaperSection = (props: PaperSectionProps) => {
  return (
    <TPOPaper color="rgba(70, 0, 116, 0.3)">
      <Box
        className="paper-section-root"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        <Typography
          sx={{
            paddingTop: 4,
            paddingLeft: 3,
            paddingBottom: !!props.subtitle ? 1 : 4,
            backgroundColor: props.variant === 'plain' ? '#ffffff' : (props.bannerColor ? props.bannerColor : 'tertiary.main'),
            color: props.variant === 'plain' ? 'text.primary' : '#ffffff',
            fontSize: '20px',
            fontWeight: 600
          }}
        >
          {props.title}
        </Typography>
        {props.subtitle && (
          <Typography
            sx={{
              paddingLeft: 3,
              paddingBottom: 3,
              backgroundColor: '#015545',
              color: '#fdfdfd',
              fontSize: '18px',
              fontWeight: 500
            }}
          >
            {props.subtitle}
          </Typography>
        )}
        <Box
          className="paper-section-content"
          sx={{
            padding: 3,
            flexGrow: 1
          }}
        >
          {props.children}
        </Box>
      </Box>
    </TPOPaper>
  );
};

export default PaperSection;
